import * as React from 'react';
import { IFilterOption, IFilterRequest, IGoogleEvent, IAppParams } from "../../models";
import { safe, removePrimitive, isNullOrUndefined, addItemToGoogleTracking } from "../../utils";
import { Tooltip } from "../"
const styles = require('./CheckBoxList.pcss');

interface IProps {
    appParams: IAppParams;
    heading?: string;
    property: string;
    options?: IFilterOption[];
    onChange?: any;
    filter?: IFilterRequest;
    isLoading?: boolean;
    tooltip?: string | null;
    gaKey?: string;
    changeSelected?: Function;
}

interface IState {

}

export class CheckBoxList extends React.Component<IProps, IState>{
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(option, gaKey, event) {
        let { changeSelected, heading, property, options, onChange, filter, appParams } = this.props;
        if (gaKey && !option.selected) {
            addItemToGoogleTracking(appParams, gaKey, { eventLabel: option.value })
        }

        if (changeSelected) {
            changeSelected(!option.selected);
        }
        if (option.value.indexOf("\\(") === -1) {
            option.value = option.value.replace("(", "\\(").replace(")", "\\)");
        }

        let isSelected = event.target.checked;
        if (!filter) {
            filter = {};
        }
        if (!filter.search) {
            filter.search = [];
        }
        let filterSearchProperty = safe(() => filter.search.filter(s => s.property === property)[0]);
        if (filterSearchProperty) {
            if (!filterSearchProperty.values) {
                filterSearchProperty.values = [];
            }
            if (isSelected) {
                filterSearchProperty.values.push(option.value);
            }
            else {
                removePrimitive(option.value, filterSearchProperty.values);
                if (filterSearchProperty.values.length === 0) {
                    removePrimitive(filterSearchProperty, filter.search);
                }
            }

        }
        else if (isSelected) {
            filter.search.push({
                property,
                matchtype: 'MATCH',
                values: [option.value]
            });
        }

        onChange(filter);
    }

    render() {
        let { heading, property, options, onChange, filter, isLoading, tooltip, gaKey } = this.props;

        if (!options) {
            options = [];
        }

        if (property === "morningstar_rating") {
            options.sort((a, b) => a.label === b.label ? 0 : a.label < b.label ? 1 : -1);
        } else {
            options.sort((a, b) => a.label === b.label ? 0 : a.label > b.label ? 1 : -1);
        }

        return (
            <div className={ styles.ksw_filters_vt }>
                <ul>
                    <li>
                        <h4>{ heading } { !isNullOrUndefined(tooltip) ? <Tooltip text={ tooltip } styles={ styles } /> : "" }</h4>
                        <ul>
                            { options.map((option, index) => {
                                if (option.value !== "0" && option.label !== "N/A") {
                                    let isFullRow = true;// option.value === "featured" || property === "morningstar_rating" || property === "regions";

                                    if (option.label === "") {
                                        option.label = "Other";
                                    }

                                    return (
                                        <li key={ option.value } className={ isFullRow ? styles.checkBoxItemFull : styles.checkBoxItem }>
                                            <label>
                                                <input
                                                    disabled={ !!isLoading }
                                                    ref={ option.value }
                                                    value={ option.value }
                                                    type="checkbox"
                                                    checked={ option.selected }
                                                    onChange={ (event) => this.handleChange(option, gaKey, event) }
                                                    className={ styles.ksw_checkBox } />
                                                { property === "morningstar_rating" ? <img height="11px" src={ require(`../../images/${ option.value }-star.svg`) } /> : option.label } <span className={ styles.labelDetail }></span>
                                            </label>
                                        </li>
                                    );
                                }
                            }) }
                        </ul>
                    </li>
                </ul>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/assets/CheckBoxList/CheckBoxList.tsx